/* globals grecaptcha */

(function () {
    'use strict';

    function main() {
        var page = wo$('#partner-program');
        if (!page.length) return;
        var clientData = WhistleOut.readLookupData(page);

        var controller = {
            init: function () {
                controller.bind();
            },

            bind: function () {
                page.find('form').submit(function (event) {
                    event.preventDefault();
                    controller.submit();
                });
            },

            error: function (message) {
                page.find('#error').html(message).show();
                page.find('#submit').removeAttr('disabled');
                page.find('#submit span').hide();
            },

            validate: function () {
                var error = '';
                page.find('form [data-required]').each(function () {
                    var $this = wo$(this);
                    if ($this.val().trim() === '') {
                        $this.parents('.form-group').addClass('has-error');
                        error = clientData.requiredFields;
                    } else {
                        $this.parents('.form-group').removeClass('has-error');
                    }
                });

                let email = page.find('#inputEmailAddress').val().trim();
                if (email) {
                    let emailPattern =
                        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                    if (!emailPattern.test(email))
                        error += error ? ' ' + clientData.invalidEmailAddress : clientData.invalidEmailAddress;
                }

                let phoneNumber = page.find('#inputPhoneNumber').val().trim();
                if (phoneNumber) {
                    if (!/^[0-9-+\s]{4,50}$/.test(phoneNumber))
                        error += error ? ' ' + clientData.invalidPhoneNumber : clientData.invalidPhoneNumber;
                }

                let postCode = page.find('#inputPostCode').val().trim();
                if (postCode) {
                    if (!/^[0-9-\s]{4,20}$/.test(postCode))
                        error += error ? ' ' + clientData.invalidPostCode : clientData.invalidPostCode;
                }

                return error;
            },

            submit: function () {
                var error = controller.validate();
                if (error !== '') {
                    controller.error(error);
                    return;
                }

                page.find('#error').hide();
                page.find('#submit').attr('disabled', '');
                page.find('#submit span').show();

                var data = {
                    Company: page.find('#inputCompany').val().trim(),
                    ContactName: page.find('#inputContactName').val().trim(),
                    Title: page.find('#inputTitle').val().trim(),
                    PhoneNumber: page.find('#inputPhoneNumber').val().trim(),
                    EmailAddress: page.find('#inputEmailAddress').val().trim(),
                    Address: page.find('#inputAddress').val().trim(),
                    City: page.find('#inputCity').val().trim(),
                    State: page.find('#inputState').val().trim(),
                    PostCode: page.find('#inputPostCode').val().trim(),
                    Country: page.find('#inputCountry').val().trim(),
                    Urls: page.find('#inputURL').val().trim(),
                    MonthlyTraffic: page.find('#inputMonthlyTraffic').val().trim(),
                    Industry: page.find('#inputIndustry').val().trim(),
                    PromotionMethod: page.find('#inputPromote').val().trim(),
                    CaptchaResponse: page.find('#captcha-response').val()
                };

                wo$.ajax({
                    url: '/Ajax/Shared/General/SubmitPartnerApplication',
                    data: data,
                    dataType: 'json',
                    type: 'POST',
                    success: function (result) {
                        if (result.success) {
                            page.find('#partner-signup-form').hide();
                            page.find('#submitted').show();
                            WhistleOut.scrollTo('#submitted');
                        } else {
                            controller.error(clientData.captchaFailed);
                            grecaptcha.reset();
                        }
                    },
                    error: function () {
                        controller.error(clientData.error);
                        grecaptcha.reset();
                    }
                });
            }
        };

        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
